import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/service/permission.service';
import { adminGuard } from './app/service/admin.guard';
import { sellerGuard } from './app/service/seller.guard';
import { organizationModeGuard } from './app/service/organization-mode.guard';
import { entRouteGuard } from './app/service/org-surface.guard';
import { orgSessionGuard } from './app/org/auth/org-session.guard';
import { RecoverySetupComponent } from './app/pages/auth/recovery-setup/recovery-setup.component';

export const appRoutes: Routes = [
    // Üyelik paneli girişi: AppLayout dışında (oturum öncesi). 'org' altı rotasından önce eşleşir.
    { path: 'org/login', loadComponent: () => import('./app/org/auth/org-login.page').then((m) => m.OrgLoginPage) },
    {
        path: '',
        component: AppLayout,
        children: [
            // KX-002/KX-017 Faz3 — kurtarma kodu kurulumu opsiyoneldir (Level-2 onboarding).
            // Hiçbir kullanıcı /recovery-setup'a zorunlu yönlendirilmez; ekran yalnızca
            // kullanıcı isterse /recovery-setup üzerinden kendi tercihiyle kurulabilir.
            // Organizasyon modu (partner hesabı): ana sayfa ve abonelik yerine Üyelik açılır (organizationModeGuard).
            // entRouteGuard = AuthGuard + org oturumu kapısı: yalnız org oturumu varken ent rotası karşılığı olan /org sayfasına yönlenir.
            { path: '', component: Dashboard, canActivate: [entRouteGuard, organizationModeGuard] },
            { path: 'portfolio', canActivate: [entRouteGuard], loadChildren: () => import('./app/pages/portfolio/portfolio.routes') },
            { path: 'info', canActivate: [entRouteGuard], loadChildren: () => import('./app/pages/info/info.routes') },
            { path: 'templates', canActivate: [entRouteGuard], loadChildren: () => import('./app/pages/templates/templates.routes') },
            { path: 'reports', canActivate: [entRouteGuard], loadChildren: () => import('./app/pages/reports/reports.routes') },
            { path: 'pages', canActivate: [entRouteGuard], loadChildren: () => import('./app/pages/pages.routes') },
            // Şirket aboneliği (Paddle): sahip hesabı; kilit yok, sayfa her durumda açılır (uiux B-uiux-2).
            { path: 'subscription', canActivate: [entRouteGuard, organizationModeGuard], loadComponent: () => import('./app/pages/subscription/subscription.component').then((m) => m.SubscriptionComponent) },
            // iyzico callback dönüşü: sunucu `https://enterprise.kartex.net/billing?checkout=&result=` adresine yönlendirir; sorgu korunur.
            { path: 'billing', redirectTo: 'subscription' },
            { path: 'recovery-setup', component: RecoverySetupComponent, canActivate: [AuthGuard] },
            // KX admin: kartexadmin realm rolüne özel yönetim alanı (adminGuard AuthGuard'dan sonra).
            { path: 'admin', canActivate: [AuthGuard, adminGuard], loadChildren: () => import('./app/pages/admin/admin.routes') },
            // Üyelik paneli (kurum web oturumu); mevcut AppLayout içinde, rota iskeleti.
            { path: 'org', canActivate: [orgSessionGuard], loadChildren: () => import('./app/org/org.routes') },
            // Satıcı portalı: kartexseller realm rolü (Faz 4 iskeleti).
            { path: 'seller', canActivate: [AuthGuard, sellerGuard], loadChildren: () => import('./app/pages/seller/seller.routes') }
        ]
    },
    { path: 'notfound', component: Notfound },
    // Şirket hesabını KarteX uygulamasına taşıma (Q8). /setup rotasını kurulum işi (e5) ayrıca ekler; burada ezilmez.
    { path: 'tasi', loadComponent: () => import('./app/pages/auth/tasi/tasi.component').then((m) => m.TasiComponent) },
    // Kurulum sihirbazı (AppLayout dışında, kendi tam ekranı); oturum kapısı setup.routes içinde.
    { path: 'setup', loadChildren: () => import('./app/pages/setup/setup.routes') },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
